<span class="dvb-gueltigkeit">
    <span data-translate="COMMON.PREPOSITION_DATUM_MF"
          data-translate-value-is-active="{{vm.active}}"
          data-translate-value-preposition="{{vm.preposition}}"
          data-translate-value-is-begin-of-time="{{vm.isBeginOfTime}}"
          data-translate-value-date="{{vm.entity.gueltigAb | amDateFormat:'D.M.YYYY'}}"
          data-translate-interpolation="messageformat">
    </span>
</span>
